<template>
  <div class="flex">
    <div class="authors-catalog__img">
      <img
        :src="result.PictureUrl ? result.PictureUrl : assignedAuthorImage"
        :alt="fullName"
      />
    </div>
    <div class="authors-catalog__container">
      <h3 class="type-h3 type-circular">{{ formattedName }}</h3>
      <p class="type-small" v-html="trimmedProfile"></p>
      <a
        :href="authorHref"
        class="type-link type-link--arrow type-small authors-catalog__profile-link"
        v-if="result.Profile !== null"
      >
        View full profile</a
      >
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";

// import { GET_CATALOG_ITEMS } from '../vuex/modules/catalog/mutations';

export default {
  name: "CatalogProduct",
  props: ["result", "catalog"],
  data() {
    return {
      pathPrefix: "a",
      assignedAuthorImage: "",
      authorImages: [
        "/images/DefaultAuthor1.jpg",
        "/images/DefaultAuthor2.jpg",
        "/images/DefaultAuthor3.jpg",
      ],
    };
  },
  created() {
    const index = Math.floor(Math.random() * this.authorImages.length);
    this.assignedAuthorImage = this.authorImages[index];
  },
  mounted() {
    // set prefix for urls based on the passed catalog.
    // since this is the author component, it will return 's'
    // so that we can build links to scripts and other shop
    // items later on.
    // this.pathPrefix = (this.catalog == 'perform') ? 'p' : 's';
  },
  methods: {
    ...mapActions({}),

    // builds the link path of the current author.
    titleHref(title) {
      return `/p/${title.Id}/${title.SeName}`;
    },
  },

  computed: {
    ...mapState({
      authors: (state) => state.catalogStore.authors,
    }),

    formattedName() {
      return `${this.result.LastName}, ${this.result.FirstName}`;
    },

    fullName() {
      return `${this.result.FirstName} ${this.result.LastName}`;
    },

    trimmedProfile() {
      if (!this.result.Profile) {
        return "";
      }
      return `${this.result.Profile.slice(0, 350)}...`;
    },

    authorHref() {
      // const seName = this.result.SeName;
      return `/${this.pathPrefix}/${this.result.Id}/${this.result.SeName}`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CatalogAuthor.vue